// pdfText.js: extracts text from a PDF ArrayBuffer using pdfjs-dist via CDN worker
import * as pdfjsLib from "pdfjs-dist/legacy/build/pdf";

// use CDN worker to avoid CRA bundling issues
// IMPORTANT: the worker version must match the installed pdfjs-dist version.
// Use jsDelivr pointing at pdfjs-dist (npm) so API and worker stay in sync.
pdfjsLib.GlobalWorkerOptions.workerSrc =
  "https://cdn.jsdelivr.net/npm/pdfjs-dist@5.4.394/build/pdf.worker.min.mjs";

export async function getPdfText(arrayBuffer) {
  const loadingTask = pdfjsLib.getDocument({ data: arrayBuffer });
  const doc = await loadingTask.promise;
  let full = "";
  for (let p = 1; p <= doc.numPages; p++) {
    const page = await doc.getPage(p);
    const txt = await page.getTextContent();
    const strs = txt.items.map((it) => it.str);
    full += strs.join(" ") + "\n";
  }
  return full;
}

// Rasterize every page of a PDF (ArrayBuffer) into a JPEG Blob, in page order.
// Used by the Sort tab's "Get PDF" import: handwritten student PDFs have no
// text layer, so we render each page to a canvas and upload it as a normal
// Image_<n>.jpg scan, then grade via the existing vision OCR pipeline.
//   scale ≈ 2.0 → ~144 DPI (pdf default is 72 DPI); high enough for handwriting
//   OCR without producing huge files. quality 0.85 keeps JPEGs compact.
export async function renderPdfToJpegBlobs(arrayBuffer, { scale = 2.0, quality = 0.85 } = {}) {
  const loadingTask = pdfjsLib.getDocument({ data: arrayBuffer });
  const doc = await loadingTask.promise;
  const blobs = [];
  try {
    for (let p = 1; p <= doc.numPages; p++) {
      const page = await doc.getPage(p);
      const viewport = page.getViewport({ scale });
      const canvas = document.createElement("canvas");
      canvas.width = Math.ceil(viewport.width);
      canvas.height = Math.ceil(viewport.height);
      const ctx = canvas.getContext("2d");
      await page.render({ canvasContext: ctx, viewport }).promise;
      const blob = await new Promise((resolve) =>
        canvas.toBlob((b) => resolve(b), "image/jpeg", quality)
      );
      if (blob) blobs.push(blob);
      // Free the page's resources before moving on (large scans add up).
      page.cleanup();
    }
  } finally {
    try { await doc.destroy(); } catch (_) { /* ignore */ }
  }
  return blobs;
}
